import {
  SET_CURRENT_QUESTION,
  SET_RETAKES,
  SET_PROGRAMMING_QUESTION_STATUS,
} from "./action";

const initialState = {
  data: null,
  retakes: 0,
  programmingQuestionStatus: "idle",
};

const currentQuestionReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CURRENT_QUESTION:
      return {
        ...state,
        data: action.payload,
      };
    case SET_RETAKES:
      return {
        ...state,
        retakes: action.payload,
      };
    case SET_PROGRAMMING_QUESTION_STATUS:
      return {
        ...state,
        programmingQuestionStatus: action.payload,
      };
    default:
      return state;
  }
};

export default currentQuestionReducer;
